export enum RiskCategory {
    Unknown = 0,
    AtRiskAbroad = 1,
    AtRiskNotAbroad = 2,
    NotAtRisk = 3,
}
